import {
  type RedirectOrderDrawerRequest,
  type RedirectOrderDrawerRequestStore,
} from '../types/redirectOrderDrawerRequest.type';

export const createRedirectOrderDrawerRequestStore = (): RedirectOrderDrawerRequestStore => {
  let request: RedirectOrderDrawerRequest | undefined;

  return {
    reset: () => {
      request = undefined;
    },
    set: (nextRequest) => {
      request = nextRequest;
    },
    take: () => {
      const currentRequest = request;
      request = undefined;
      return currentRequest;
    },
  };
};
